module.exports = __webpack_public_path__ + "img/back.d32ff78a.jpg";